<template>
  <v-dialog
    persistent
    v-model="openDialog"
    @keydown.esc="openDialog = false"
    max-width="1200px"
    :fullscreen="$vuetify.breakpoint.smAndDown || fullscreenDialog"
    content-class="conversation-box-dialog"
  >
    <conversation-box
      :selected-conversation-id="conversationId"
      :current-user="currentUser"
      :is-open="openDialog"
      @markAsUnseen="markAsUnseen"
      @closeConversationDialog="openDialog = false"
      :fullscreen-dialog.sync="fullscreenDialog"
      @change-company="changeCompany"
    />
  </v-dialog>
</template>

<script>
import API from '@/api';
import ConversationBox from '@/components/ConversationBox';
import { mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'ConversationDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    conversationId: {
      type: Number,
      default: null,
    },
  },
  components: {
    ConversationBox,
  },
  watch: {
    value(newVal) {
      this.openDialog = newVal;
      if (newVal) {
        this.updateConversationAsSeen();
      }
    },
    openDialog(newVal) {
      this.$emit('input', newVal);
    },
  },
  methods: {
    changeCompany(id) {
      this.$emit('change-company', id);
    },
    async updateConversationAsSeen() {
      try {
        await API.conversation.updateConversationAsSeen(this.conversationId);
        await this.$store.dispatch(
          'updateConversationAsSeen',
          this.conversationId,
        );
        this.$store.dispatch('getMyConversations');
      } catch (error) {
        console.log(error);
      }
    },
    markConversationAsUnseen(conversation) {
      conversation.unseen_messages[
        conversation.unseen_messages.length - 1
      ].unseen_user_ids.push(this.currentUser.id);
      return conversation;
    },
    async markAsUnseen() {
      this.openDialog = false;
      if (
        isEmpty(
          this.myConversations.find(c => c.id === this.conversationId)
            .unseen_messages,
        )
      ) {
        this.$store.dispatch('getMyConversations');
      } else {
        const conversation = this.myConversations.map(c =>
          c.id === this.conversationId ? this.markConversationAsUnseen(c) : c,
        );
        this.$store.dispatch('setMyConversations', conversation);
      }
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'user',
      myConversations: 'myConversations',
    }),
  },
  data() {
    return {
      openDialog: false,
      fullscreenDialog: false,
    };
  },
  created() {
    this.openDialog = this.value;
  },
};
</script>

<style scoped></style>

<style lang="postcss">
/* not scopeable*/
.conversation-box-dialog {
  display: flex;
  flex-direction: column;
}
</style>
